import { makeStyles } from "@mui/styles";

import SecondaryButton from "@/components/UI/SecondaryButton/SecondaryButton";
import { ELEMENT_METHOD } from "@/constants";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "32px",
  },
  title: {
    display: "flex",
    justifyContent: "center",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 700,
  },
});

export default function ElementMethod(props) {
  const { setValue, type } = props;
  const classes = useStyles();

  return (
    <div data-testid="element-method-container" className={classes.container}>
      <span className={classes.title}>Would you like to upload or record?</span>
      <SecondaryButton
        onClick={() => setValue("memoMethod", ELEMENT_METHOD.UPLOAD)}
        data-testid={`element-method-${ELEMENT_METHOD.UPLOAD}-button`}
        data-analytics={`${type}-${ELEMENT_METHOD.UPLOAD}`}
      >
        Upload
      </SecondaryButton>
      <SecondaryButton
        onClick={() => setValue("memoMethod", ELEMENT_METHOD.RECORD)}
        data-testid={`element-method-${ELEMENT_METHOD.RECORD}-button`}
        data-analytics={`${type}-${ELEMENT_METHOD.RECORD}`}
      >
        Record
      </SecondaryButton>
      <SecondaryButton
        onClick={() => setValue("memoMethod", ELEMENT_METHOD.FROM_LIBRARY)}
        data-testid={`element-method-${ELEMENT_METHOD.FROM_LIBRARY}-button`}
        data-analytics={`${type}-${ELEMENT_METHOD.FROM_LIBRARY}`}
      >
        Select from Asset Library
      </SecondaryButton>
    </div>
  );
}
